import { CalendarWeek, ChevronRight, ClockHistory, LockFill } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

import { Button, Typography } from 'antd';

import ImageRatio from '@/components/shared/ImageRatio';
import { formatDate } from '@/helpers/formatDate';
import { blockedStatus, enStatus } from '@/interfaces/course';
import { ILesson } from '@/interfaces/lesson';
import styled, { css, StyledProp } from '@/styled';

interface IProps extends StyledProp {
  lesson: ILesson;
  moduleId?: string;
}

const LessonItem = (props: IProps) => {
  const navigate = useNavigate();

  const goToLesson = () => {
    navigate(`/curso/${props.lesson?.hash_course}/aula/${props.lesson?.id}`);
  };

  return (
    <div className={props.className} id={props.moduleId}>
      <ImageRatio aspect='16:9' src={props.lesson?.image} onClick={goToLesson} />

      <div className='info-section'>
        <Typography.Title level={4} ellipsis={{ rows: 2 }}>
          {props.lesson?.title}
        </Typography.Title>
        {props.lesson?.author?.name && (
          <Typography.Paragraph ellipsis>{props.lesson?.author?.name}</Typography.Paragraph>
        )}
        {props.lesson?.release && props.lesson?.status === enStatus.NOT_RELEASED && (
          <span className='info-section-status'>
            <CalendarWeek size={20} />
            <Typography.Paragraph ellipsis>Estreia dia {formatDate(props.lesson?.release)}</Typography.Paragraph>
          </span>
        )}
        {props.lesson?.status === enStatus.EXPIRED && (
          <span className='info-section-status'>
            <ClockHistory size={20} />
            <Typography.Paragraph ellipsis>Aula Expirada em {formatDate(props.lesson.expired_at)}</Typography.Paragraph>
          </span>
        )}
        {props.lesson?.status === enStatus.BLOCKED && (
          <span className='info-section-status'>
            <LockFill size={20} />
            <Typography.Paragraph ellipsis>Aula Bloqueada</Typography.Paragraph>
          </span>
        )}
      </div>
      <Button
        aria-label='Botão iniciar aula'
        disabled={blockedStatus.includes(props.lesson?.status)}
        onClick={goToLesson}
      >
        Ver aula
        <ChevronRight />
      </Button>
    </div>
  );
};

export default styled(LessonItem)(({ theme }) => {
  return css`
    display: grid;
    grid-template-columns: 224px auto 112px;
    grid-column-gap: ${theme.space.pxToRem(24)};
    grid-row-gap: ${theme.space.pxToRem(8)};
    align-items: center;

    ${theme.breakpoints.down('sm')} {
      grid-template-columns: auto;

      button {
        min-width: 100%;
        justify-content: center;
      }
    }

    .info-section {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: ${theme.space.pxToRem(12)};

      .info-section-status {
        display: flex;
        align-items: flex-end;
        gap: 8px;

        > div {
          color: ${theme.colorTextTertiary};
        }
      }

      ${theme.breakpoints.down('sm')} {
        gap: ${theme.space.pxToRem(16)};
      }
    }

    button {
      height: 40px;
      display: flex;
      align-items: center;
      column-gap: ${theme.space.pxToRem(8)};
      background: ${theme.variables.courseButtonWatchLesson};
      border: 0;
    }
  `;
});
